import { axios } from '@/plugins/axios';
import { VaccinationFolder } from '@/store/folder/types';
import { InfosDelegation } from '@/components/MesParametres/ParametresVaccination/ParametresDelegation/types';
import { createUrl } from '@/services/urlsFormatter';
import { formatDateWithOrigin } from '@/services/dateFormatter';

export function getFolderDegrade(
	nomFamille: string, nomUsage: string, prenom: string, dateNaissance: string,
	psDelegation: InfosDelegation| undefined) {

	const queryParams: { [key: string]: string; } = {};

	if (psDelegation) {
		queryParams.nomDelegation = psDelegation.nom;
		queryParams.prenomDelegation = psDelegation.prenom;
		queryParams.dateNaissanceDelegation = psDelegation.dateNaissance;
	}

	queryParams.nomFamille = nomFamille;
	queryParams.nomUsage = nomUsage;
	queryParams.prenom = prenom;
	queryParams.dateNaissance = formatDateWithOrigin(dateNaissance, 'DD/MM/YYYY', 'YYYY-MM-DD');

	return axios.get(createUrl('/vaccination-covid-api/folders-degrade', queryParams));
}

export function getFolderByVoucherCode(voucherCode: string, psDelegation: InfosDelegation| undefined) {
	return axios.get(createSearchUrl('voucherNumber=' + voucherCode, psDelegation));
}

export function getFullFolderByVoucherCode(
	numeroBon: string, prescriptionId: number | undefined, psDelegation: InfosDelegation | undefined) {

	const queryParams: { [key: string]: string; } = {};
	if (prescriptionId) {
		queryParams.prescriptionId = prescriptionId?.toString() || '';
	}

	if (psDelegation) {
		queryParams.nomDelegation = psDelegation.nom;
		queryParams.prenomDelegation = psDelegation.prenom;
		queryParams.dateNaissanceDelegation = psDelegation.dateNaissance;
	}

	return axios.get(createUrl(`/vaccination-covid-api/folders/${numeroBon}`, queryParams));
}

export function getFolderByNir(nir: string, psDelegation: InfosDelegation | undefined, fullSearch: boolean) {
	return axios.get(createSearchUrl('nir=' + nir + '&fullSearch=' + fullSearch, psDelegation));
}

export function completeFolder(request: VaccinationFolder) {
	return axios.post('/vaccination-covid-api/folders/complete', request);
}

function createSearchUrl(params: string, psDelegation: InfosDelegation | undefined): string {
	const url = '/vaccination-covid-api/folders?' + params;
	return addDelegationParamToUrl(psDelegation, url);
}

function addDelegationParamToUrl(psDelegation: InfosDelegation | undefined, url: string ) {
	if (psDelegation) {
		url += '&nomDelegation=' + psDelegation.nom;
		url += '&prenomDelegation=' + psDelegation.prenom;
		url += '&dateNaissanceDelegation=' + psDelegation.dateNaissance;
	}
	return url;
}
